module.exports = __webpack_public_path__ + "static/notfound-8b844af823ab3419c501c12030dad924.png";